import axios from 'axios';
import {withoutComma} from "../../../utils/calculate/Amount";

export class OrderAdminService {
    getAdminOrders(
        lender,
        borrower,
        isAdmin) {
        return axios.get('/appapv/getAdminOrders.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idInstitucionPrestamista: lender.idInstitucion,
                idInstitucionPrestatario: borrower.idInstitucion,
                bandera: isAdmin ? 1 : 0,
            }
        }).then(res => res.data.payload[0]);
    }

    rejectOrderAdmin(
        loanId,
        lenderOrderId,
        borrowerOrderId,
        status
    ) {
        return axios.post('/appapv/rejectOrderAdmin.action', {}, {
            params: {
                idFolioPrest: loanId,
                idFolioValPrestable: lenderOrderId,
                idFolioSolVal: borrowerOrderId,
                status: status
            }
        }).then(res => res.data.payload);
    }

    insertLenderOrderAdmin(
        lenderId,
        instrumentId,
        account,
        titles,
        maturity,
        rateValue,
        surcharge,
        maturityType,
        valudeDate,
        borrowerOrderId
    ) {
        return axios.post('/appapv/insertLenderOrderAdmin.action', {}, {
            params: {
                idInstitucionPrestamista: lenderId,
                idEmisora: instrumentId,
                cuenta: account,
                cantidadPostura: withoutComma(titles),
                plazo: maturity,
                tasa: rateValue / 100,
                sobreTasa: surcharge / 100,
                vigencia: maturityType,
                fecValor: valudeDate,
                idFolioSolVal: borrowerOrderId
            }
        }).then(res => res.data);
    }

    insertBorrowerOrderAdmin(
        borrowerId,
        instrumentId,
        titles,
        maturity,
        rateValue,
        surcharge,
        maturityType,
        valudeDate,
        lenderOrderId
    ) {
        return axios.post('/appapv/insertBorrowerOrderAdmin.action', {}, {
            params: {
                idInstitucionPrestatario: borrowerId,
                idEmisora: instrumentId,
                cantidadPostura: withoutComma(titles),
                plazo: maturity,
                tasa: rateValue / 100,
                sobreTasa: surcharge / 100,
                vigencia: maturityType,
                fecValor: valudeDate,
                idFolioValPrestable: lenderOrderId
            }
        }).then(res => res.data);
    }

    updateOrderAdmin(
        loanId,
        lenderOrderId,
        borrowerOrderId,
        status,
        titles,
        maturity,
        rateValue,
        surcharge
    ) {
        return axios.post('/appapv/updateOrderAdmin.action', {}, {
            params: {
                idFolioPrest: loanId,
                idFolioSolVal: borrowerOrderId,
                idFolioValPrestable: lenderOrderId,
                status: status,
                cantidadPostura: withoutComma(titles),
                plazo: maturity,
                tasa: rateValue,
                sobreTasa: surcharge
            }
        }).then(res => res.data);
    }

    insertTradeAdmin(
        lenderId,
        borrowerId,
        instrumentId,
        account,
        titles,
        maturity,
        rate,
        surcharge,
        maturityType,
        valueDate
    ) {
        return axios.post('/appapv/insertTradeAdmin.action', {}, {
            params: {
                idInstitucionPrestamista: lenderId,
                idInstitucionPrestatario: borrowerId,
                idEmisora: instrumentId,
                cuenta: account,
                cantidadPostura: withoutComma(titles),
                plazo: maturity,
                tasa: rate / 100,
                sobreTasa: surcharge / 100,
                vigencia: maturityType,
                fecValor: valueDate
            }
        }).then(res => res.data);
    }
}
